import { useEffect } from "react";
import { useHistory } from "react-router-dom";

const PreventBackNavigation = () => {
  const history = useHistory();

  useEffect(() => {
    const handleBack = () => {
      history.go(1); // Moves forward if the user tries to go back
    };

    window.addEventListener("popstate", handleBack);

    return () => {
      window.removeEventListener("popstate", handleBack);
    };
  }, [history]);

  return null;
};

export default PreventBackNavigation;
